import { render, staticRenderFns } from "./UpgradeSubscriptionPage.vue?vue&type=template&id=55f5b1af&scoped=true&"
import script from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"
export * from "./UpgradeSubscriptionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5b1af",
  null
  
)

export default component.exports